var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54165 9.20836H11.4537L7.99706 12.665C7.72081 12.9413 7.72081 13.3946 7.99706 13.6709C8.27331 13.9471 8.71956 13.9471 8.99581 13.6709L13.6637 9.00295C13.94 8.7267 13.94 8.28045 13.6637 8.0042L9.0029 3.3292C8.72665 3.05295 8.2804 3.05295 8.00415 3.3292C7.7279 3.60545 7.7279 4.0517 8.00415 4.32795L11.4537 7.7917H3.54165C3.15206 7.7917 2.83331 8.11045 2.83331 8.50003C2.83331 8.88961 3.15206 9.20836 3.54165 9.20836Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreyIcon);
export default __webpack_public_path__ + "static/media/ArrowRightGreyIcon.94912af2.svg";
export { ForwardRef as ReactComponent };